module.exports = __webpack_public_path__ + "static/img/dlt1.a2dc89c4.png";